import React, { SVGProps } from 'react';

const LockOpenIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M9.9998 5.83403H4.33348V5.31872C4.33376 3.7621 5.59587 2.50047 7.15249 2.50075C8.17739 2.50094 9.12142 3.05746 9.6178 3.95412C9.88581 4.43697 10.4945 4.61111 10.9774 4.3431C11.4602 4.07508 11.6344 3.46637 11.3663 2.98353C10.0764 0.655992 7.14383 -0.185109 4.8163 1.10484C3.28439 1.95385 2.3338 3.56727 2.33361 5.31872V6.23866C1.10757 6.86434 0.33524 8.12398 0.33374 9.50045V12.8336C0.335959 14.8576 1.97617 16.4978 4.00016 16.5H9.99977C12.0238 16.4978 13.664 14.8576 13.6662 12.8336V9.50045C13.664 7.47646 12.0238 5.83625 9.9998 5.83403ZM11.6664 12.8336C11.6664 13.754 10.9202 14.5001 9.9998 14.5001H4.00019C3.07978 14.5001 2.33364 13.754 2.33364 12.8336V9.50045C2.33364 8.58004 3.07978 7.8339 4.00019 7.8339H9.9998C10.9202 7.8339 11.6664 8.58004 11.6664 9.50045V12.8336Z"
                fill="#8DD690"
            />
            <path
                d="M6.66668 9.83325H7.33329C7.88554 9.83325 8.33323 10.2809 8.33323 10.8332C8.33323 11.3854 7.88554 11.8331 7.33329 11.8331H6.66668C6.11444 11.8331 5.66675 11.3854 5.66675 10.8332C5.66675 10.2809 6.11444 9.83325 6.66668 9.83325Z"
                fill="#8DD690"
            />
        </svg>
    );
};

export default LockOpenIcon;
